import { render, staticRenderFns } from "./ExtendedDetails.vue?vue&type=template&id=434a08b5&"
import script from "./ExtendedDetails.vue?vue&type=script&lang=js&"
export * from "./ExtendedDetails.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports